import { Fragment } from 'react';
import type { Filter } from '@/app/common/filters/core/filtersTypes.ts';
import { filterComponentsOf } from '@/app/common/filters/types/filterTypeComponents.ts';
import { noop } from '@/app/components/search/Utilities.ts';
import type { HandleFilterChanged } from '@/app/common/filters/core/filterComponentType.ts';
import type { CustomFilterMainCreators } from '@/app/common/filters/surfaces/forms/FilterGroupsComponents.tsx';
import type { FILTER_SURFACE } from '@/app/common/filters/surfaces/forms/custom/customFilterMainCreators.ts';
import { chipsPresentationOf } from '@/app/common/filters/surfaces/forms/custom/customFilterMainCreators.ts';
import { useFiltersUiData } from '@/app/common/filters/surfaces/provider/filtersUiProvider.tsx';
import styled from 'styled-components';

const ChipSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.kallisto.space.space250};
`;

type FilterGroupProps = {
  filters: Filter[];
  customFilterMainCreators?: CustomFilterMainCreators;
  isLoading: boolean;
  handleFilterChanged: HandleFilterChanged;
  columns?: number;
  columnGap?: number;
  surface: FILTER_SURFACE;
};

export const FilterGroupFilters = ({
  filters,
  customFilterMainCreators,
  isLoading,
  handleFilterChanged,
  columns,
  columnGap,
  surface,
}: FilterGroupProps) => {
  const { useEvoFilters } = useFiltersUiData();

  const entries = filters.map((filter) => ({
    filter,
    Main: customFilterMainCreators?.[filter.name] || filterComponentsOf(filter).Main || noop,
    chips: chipsPresentationOf(filter.name, surface, useEvoFilters),
  }));

  const Sections = entries.some((entry) => entry.chips) ? ChipSections : Fragment;

  return (
    <Sections>
      {entries.map(({ filter, Main, chips }) => (
        <Main
          key={filter.name}
          columns={columns}
          columnGap={columnGap}
          maxVisibleOptions={chips?.maxVisible}
          filter={filter}
          isLoading={isLoading}
          handleFilterChanged={handleFilterChanged}
        />
      ))}
    </Sections>
  );
};
